import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ImagesDataFetcherService } from '@shared/services/image-feed/images-data-fetcher.service';
import { PainterService } from '@shared/services/image-feed/painter.service';
import { LabelingTaskPrivileges } from '../labeling.component';
import { ColorMeaning, LabelingColorService } from '../services/labeling-color.service';
import { LabelingReviewDataFetcherService } from '../services/labeling-review-data-fetcher.service';
import { LabelingService } from '../services/labeling.service';
import { LabelingReviewAnnotationGroupService } from './services/labeling-review-annotation-group.service';
import { LabelingReviewImagePainterService } from './services/labeling-review-image-painter.service';
import { LabelingReviewImagePathService } from './services/labeling-review-image-path.service';
import { LabelingReviewUpdateService } from './services/labeling-review-update.service';
import { LabelingValidateService } from './services/labeling-validate.service';

@UntilDestroy()
@Component({
    selector: 'labeling-task-review',
    templateUrl: './labeling-task-review.component.html',
    styleUrls: ['./labeling-task-review.component.less'],
    providers: [
        LabelingReviewAnnotationGroupService,
        LabelingReviewImagePathService,
        LabelingValidateService,
        LabelingReviewUpdateService,
        LabelingReviewDataFetcherService,
        { provide: ImagesDataFetcherService, useExisting: LabelingReviewDataFetcherService },
        LabelingReviewImagePainterService,
        { provide: PainterService, useExisting: LabelingReviewImagePainterService }
    ]
})
export class LabelingTaskReviewComponent implements OnInit {
    @Input() privilegesOnTask: LabelingTaskPrivileges;

    constructor(
        private labelingColorService: LabelingColorService,
        private labelingService: LabelingService
    ) {}

    ngOnInit() {
        // get annotator ids and associate color to each
        this.labelingService.listAnnotatorsIds().pipe(
            untilDestroyed(this)
        ).subscribe((annotatorIds) => {
            this.labelingColorService.setColorOptions(ColorMeaning.ANNOTATOR, annotatorIds);
        });
    }
}
